(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["thelone-product-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('thelone-offers')) {
    customElements.define('thelone-offers', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const scope = this.closest('product-component') || this.closest('.shopify-section');
        this.addEventListener('change', (event) => {
          const input = event.target;
          if (!input.matches('input[data-quantity]')) return;
          const form = scope.querySelector('product-form-component');
          const quantity = form?.querySelector('input[name="quantity"]');
          if (quantity) {
            quantity.value = input.dataset.quantity;
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const variantInput = form?.querySelector('input[name="id"]');
          if (!variantInput || variantInput.value === input.value) return;
          const picker = scope.querySelector('variant-picker');
          const url = new URL(this.dataset.productUrl, location.origin);
          url.searchParams.set('variant', input.value);
          url.searchParams.set('section_id', this.dataset.sectionId);
          if (picker?.fetchUpdatedSection) {
            picker.fetchUpdatedSection(url, { detail: { variantId: input.value } });
          } else {
            url.searchParams.delete('section_id');
            location.assign(url);
          }
        }, { signal: this.controller.signal });
        scope.addEventListener('change', (event) => {
          if (!event.target.matches('input[name="quantity"]')) return;
          const selected = this.querySelector('input:checked');
          if (selected && selected.dataset.quantity !== event.target.value) selected.checked = false;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["thelone-product-review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('thelone-product-review-carousel')) {
    customElements.define('thelone-product-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.slideshow = this.querySelector('slideshow-component');
        const initialReview = this.querySelector('[ref="slides[]"]');
        if (initialReview instanceof Element) this.activateReview(initialReview);

        this.addEventListener('slideshow:select', event => {
          if (event.target !== this.slideshow) return;
          const review = event.detail?.slide;
          if (review instanceof Element) this.activateReview(review);
        }, { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      activateReview(review) {
        if (review === this.activeReview) return;
        this.activeReview = review;
        this.selectRandomMedia(review);
      }

      selectRandomMedia(review) {
        const candidates = [...review.querySelectorAll('[data-review-media-candidate]')];
        if (candidates.length === 0) return;

        const selectedIndex = Math.floor(Math.random() * candidates.length);
        candidates.forEach((candidate, index) => {
          candidate.hidden = index !== selectedIndex;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
